import { FiClock, FiMonitor, FiUsers } from "react-icons/fi";
import { formatDateTime, formatDocument, formatElapsed, getInitials } from "../../utils.js";
import styles from "./css/companyCard.module.css";


export default function CompanyCard({ company, onOpenUsers }) {
    const hasUsers = company.connectedUsers > 0;

    return (
        <article className={styles.card}>
            <header className={styles.cardHeader}>
                <div className={styles.avatar}>{getInitials(company.name)}</div>

                <div className={styles.identity}>
                    <h3 className={styles.name} title={company.name}>{company.name}</h3>
                    <span className={styles.document}>{formatDocument(company.document)}</span>
                </div>

                {!company.operating && <span className={styles.blockedBadge}>Bloqueada</span>}
            </header>

            <div className={`${styles.usersPanel} ${hasUsers ? styles.usersPanelOn : styles.usersPanelOff}`}>
                <span className={`${styles.statusDot} ${hasUsers ? styles.statusDotOn : ""}`} />
                <FiUsers size={20} />
                <span className={styles.usersCount}>{company.connectedUsers}</span>
                <span className={styles.usersLabel}>
                    {company.connectedUsers === 1 ? "usuário conectado" : "usuários conectados"}
                </span>
            </div>

            <ul className={styles.infoList}>
                <li className={styles.infoItem} title={`Aberto em ${formatDateTime(company.openedAt)}`}>
                    <FiClock size={15} />
                    <span>Turno #{company.sequenceNumber} · aberto há <b>{formatElapsed(company.openedAt)}</b></span>
                </li>

                <li className={`${styles.infoItem} ${company.localAppConnected ? styles.infoOn : styles.infoOff}`}>
                    <FiMonitor size={15} />
                    <span>{company.localAppConnected ? "App local conectado" : "App local desconectado"}</span>
                </li>
            </ul>

            <button type="button" className={styles.usersButton} onClick={() => onOpenUsers(company)}>
                Ver usuários
            </button>
        </article>
    );
}
